import { getBlock } from '../content';

function TickerTrack({ items, className = '', separator = '✦' }) {
  return (
    <div className="ticker">
      {[0, 1].map(i => (
        <div key={i} className={`ticker-track ${className}`} aria-hidden={i > 0}>
          {items.map((item, j) => (
            <span key={j}>
              {item} <span className="s">{separator}</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}

export default function Ticker() {
  const c = getBlock('home.ticker');
  return (
    <div className="ticker-block">
      <TickerTrack items={c.words} separator={c.separator} />
    </div>
  );
}
